// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-roxanne -> repli-training-roxanne -> the-roxanne
// Generated: 2026-08-24T18:45:05.767Z
// Counts: 4 design, 9 content, 17 slot group, 0 collection binding, 0 section, 0 style

export const designOverrides = {
  "design._site.font.accent": {
    "cssVariable": "--vibe-font-accent",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.font.body": {
    "cssVariable": "--vibe-font-body",
    "overrideType": "VALUE",
    "value": "'Work Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Cormorant Garamond', serif",
    "mappedField": null
  },
  "design._site.font.mono": {
    "cssVariable": "--vibe-font-mono",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "contactform.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Fill out the form below, drop us a line, or stop by to learn how you can start living in <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span><strong>Experience</strong></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Experience</h1><h1> <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Fill out the form below, drop us a line, or stop by to learn how you can start living in <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Have Questions?</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to your new home.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentreviews.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Resident Reviews</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Living, Reimagined</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Live above Midtown’s Arts District at The Roxanne.</strong> From West Peachtree, you’re moments from Arts Center MARTA, the High Museum, Woodruff Arts Center, Colony Square dining and the everyday energy that makes Midtown Atlanta feel connected, walkable and unmistakably urban.</p><p>Inside, choose from <a class=\"richtext-link\" href=\"/floor-plans\">studio, one-, two- and three-bedroom residences</a>, including penthouse layouts, with modern kitchens, quartz surfaces, imported cabinetry, light wood-patterned porcelain floors, walk-in closets, in-home laundry and balconies with city views. Beyond your door, <a class=\"richtext-link\" href=\"/amenities\">resort-style amenities</a> extend the skyline experience: an elevated pool with waterfall feature, sundeck with cabana and grills, panoramic fitness center, resident lounge with demo kitchen, concierge, package receiving, bike storage, covered garage parking and Wi-Fi-equipped common areas.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "pet-policy-hero.back_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166567/01a01589-a7d1-7315-9407-e7c9a5ec19d5.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A person playfully interacting with a happy white Akita Inu dog outdoors, showcasing companionship and joy."
      }
    }
  },
  "pet-policy-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166567/01a0158c-f88d-77d5-bf1f-79640d37de42.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A white Labrador retriever walking on a sunny autumn day on a garden path."
      }
    }
  },
  "pet-policy-hero.front_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166567/01a0158a-5bc4-71f4-a305-fe0f39fb8ca9.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Adorable calico cat relaxing on a sofa indoors with a yellow pillow, peaceful ambiance."
      }
    }
  },
  "residentreviews.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166567/01a0102b-3118-7268-b846-f2c7f348f210.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A smiling family, a man, a woman, and a young girl, reading a book together on a bed."
      }
    }
  },
  "contactform.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-b70e-7436-a842-739c254d8983.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Rooftop lounge with city skyline at sunset"
      }
    }
  },
  "gallerystrip.image1": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "gallerystrip.image2": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "gallerystrip.image3": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "gallerystrip.image4": {
    "sourceIndex": 18,
    "fieldOverrides": null
  },
  "herosolidbg.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167726/01a02508-ff65-758d-b41e-88ac042998fa.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bright open-concept living room with a leather sofa and coffee table beside a modern kitchen."
      }
    }
  },
  "neighborhoodspotlight.after_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a0259a-03a9-768c-ab07-459506bb587d.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A panoramic view showcasing the vibrant Atlanta skyline with a Ferris wheel in the foreground."
      }
    }
  },
  "neighborhoodspotlight.before_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a0259a-04a0-76cd-98ad-f04a677f039b.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Stunning aerial view of Atlanta's modern skyline under a clear blue sky."
      }
    }
  },
  "pageintro.back_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-d372-73ce-8b93-a6816b56afa5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Furnished living and dining area with a modern kitchen and Midtown Atlanta city views."
      }
    }
  },
  "pageintro.front_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-df7f-733b-9182-cc6801be2e08.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Stylish bedroom with a queen-size bed and expansive windows framing city views."
      }
    }
  },
  "pinnedcallouts.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-b70e-7436-a842-739c254d8983.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Rooftop lounge with city skyline at sunset"
      }
    }
  },
  "propertyoverview.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-a839-7169-92d1-955b31bc2fa5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor lounge area with chaise lounges, covered seating, and a barbecue grill."
      }
    }
  },
  "propertyoverview.fg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-df7f-733b-9182-cc6801be2e08.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A stylish bedroom with a queen-size bed, a ceiling fan, and large windows with a view."
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {};

export const styleOverrides = {};
